import { PriceUtils } from '../price/price-mapper';
export class PaymentDtoMapper {
    constructor(regionalSettings, formatter) {
        this.regionalSettings = regionalSettings;
        this.formatter = formatter;
        this.formatter = formatter || ((key) => key);
    }
    priceText(paymentDto, currencyDisplay) {
        const { isFree, priceText, price } = paymentDto;
        const shouldShowPrice = !isFree && price;
        if (priceText) {
            return priceText;
        }
        if (shouldShowPrice) {
            return this.getFormattedPrice(paymentDto, currencyDisplay);
        }
        return '';
    }
    getFormattedPrice(paymentDto, currencyDisplay) {
        const { currency, price, minPrice, maxPrice } = paymentDto;
        if (minPrice) {
            if (minPrice.price === maxPrice.price) {
                return PriceUtils.getFormattedCurrency({
                    price: minPrice.price,
                    currency: minPrice.currency,
                    locale: this.regionalSettings,
                    currencyDisplay,
                });
            }
            return this.formatter(PriceUtils.getFormattedCurrency({
                price: minPrice.price,
                currency: minPrice.currency,
                locale: this.regionalSettings,
                currencyDisplay,
            }));
        }
        return PriceUtils.getFormattedCurrency({
            price,
            currency,
            locale: this.regionalSettings,
            currencyDisplay,
        });
    }
}
//# sourceMappingURL=payment-dto.mapper.js.map